import React from 'react';
import {
    LinearProgress,
    Table,
    TableBody,
    TableContainer,
} from '@mui/material';
import { useTaxesList } from '../../../contextsProperty/ContextTaxes';
import Card from '../../../../muiComponents/Card';
import TableHeader from '../../../../Table/TableHeader';
import TaxRow from './TaxRow';
import { taxesTableColumns } from '../../../../utils/taxes/taxesListUtils';
import useTranslate from '../../../../customHooks/useTranslate';
import '../../../../stylesheets/stylesLayout/taxes-list.scss';

const TaxList = () => {
    const {
        items,
        isLoading,
        sortDir,
        sortedBy,
        handleSortByField,
        handleScroll,
    } = useTaxesList();
    const translate = useTranslate();

    return (
        <Card className='flex-column flex-grow min-height-0'>
            <TableContainer
                className=' flex-grow min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={handleScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={taxesTableColumns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={handleSortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map(item => (
                            <TaxRow key={item.Id} tax={item} />
                        ))}
                    </TableBody>
                    {items.length === 0 && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default TaxList;
